<template>
  <div class="card w-full">
    <transition name="modal">
      <address-modal
        v-if="showAddressModal"
        @close="showAddressModal = false"
        @addressAdded="
          showAddressModal = false;
          $emit('updateAddresses');
        "
      ></address-modal>
    </transition>

    <card-header :title="'Orden #' + order.id">
      <template #badge>
        <status-badge status="in_process" />
      </template>
    </card-header>

    <p class="text-xs text-content-400">
      Última actualización: {{ formatDatetime(order.updated_at) }}
    </p>

    <div class="detail-grid mt-2">
      <detail-field label="Cliente">
        <router-link
          :to="{
            name: 'clientsDetail',
            params: { id: order.client.id },
          }"
          class="underline system-button"
          >{{ order.client.name }} {{ order.client.last_name }}</router-link
        >
      </detail-field>

      <detail-field v-if="order.diet && order.diet.pet" label="Mascota">
        <router-link
          :to="{
            name: 'petsDetail',
            params: { id: order.diet.pet.id },
          }"
          class="underline system-button"
          >{{ order.diet.pet.name }}</router-link
        >
      </detail-field>

      <detail-field label="Fecha de entrega programada" :value="formatDate(order.min_delivery_date)" />

      <detail-field
        v-if="order.delivery_date"
        label="Fecha de entrega realizada"
        :value="formatDatetime(order.delivery_date)"
      />

      <detail-field label="Semanas" :value="order.weeks" />

      <detail-field label="Método de entrega" :value="order.pickup_delivery ? 'Pick-Up' : 'Envío'" />
      <!-- <div v-if="!order.pickup_delivery" class="flex flex-wrap space-x-2">
        <button class="secondary-button mt-2" @click.prevent="$emit('pickup')">
          Recoger en sucursal
        </button>

        <button
          class="secondary-button mt-2"
          @click.prevent="changeToSendDelivery = true"
        >
          Cambiar dirección de entrega
        </button>
      </div>
      <button
        v-else-if="!changeToSendDelivery"
        class="secondary-button mt-2"
        @click.prevent="changeToSendDelivery = true"
      >
        Cambiar a Envío a Domicilio
      </button> -->
    </div>

    <!-- <button
      v-if="changeToSendDelivery"
      class="delete-button mt-2"
      @click.prevent="
        changeToSendDelivery = false;
        newAddressId = null;
      "
    >
      Cancelar
    </button> -->

    <!-- <div v-if="changeToSendDelivery" class="w-full mt-2">
      <label for="delivery_address">Dirección de entrega</label>

      <custom-select
        class=""
        id="delivery_address"
        v-model="newAddressId"
        :options="getDeliveryAddressOptions()"
      />

      <button
        class="link text-sm font-base"
        @click.prevent="showAddressModal = true"
      >
        Agregar otra
      </button>

      <primary-button
        v-if="newAddressId"
        class="w-24 mx-0 mt-6"
        @buttonClicked="$emit('send', newAddressId)"
        >Confirmar</primary-button
      >
    </div> -->

    <div v-if="order.address && !order.pickup_delivery" class="mt-2 text-sm">
      <p class="detail-label">Dirección</p>
      <address-component
        :address="order.address"
        :showShippingPrice="true"
        :branchId="order.branch_id"
      />
    </div>

    <branch-component class="mt-2" :branch="order.branch" />

    <div
      class="mt-2 text-sm"
      v-if="
        !order.pickup_delivery &&
        order.related_shipment_orders &&
        order.related_shipment_orders.length > 0
      "
    >
      <p class="font-medium">
        Esta orden debe enviarse con las siguientes órdenes:
      </p>
      <div class="flex space-x-2">
        <p
          v-for="relatedOrder in order.related_shipment_orders"
          :key="relatedOrder.id"
          class="text-sm text-content-400"
        >
          #{{ relatedOrder.id }}
        </p>
      </div>
      <!-- <button class="secondary-button" @click.prevent="$emit('separate')">
        Enviar order por separado
      </button> -->
    </div>

    <slot></slot>
  </div>
</template>

<script>
import OptionsMenu from "../ui/OptionsMenu";
import AddressComponent from "../ui/Address";
import BranchComponent from "../ui/Branch";
import AddressModal from "../modals/AddressModal";
import { formatDate, formatDatetime } from "@/utils/dateFormatter";
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "In Process",

  components: {
    OptionsMenu,
    AddressComponent,
    BranchComponent,
    AddressModal,
  },

  data() {
    return {
      changeToSendDelivery: false,
      newAddressId: null,
      showAddressModal: false,
    };
  },

  props: {
    order: Object,
  },

  methods: {
    formatDate,

    formatDatetime,

    integerToCurrency,

    getOptions(order) {
      let options = [{ action: "pickup", label: "Recoger en sucursal" }];

      if (
        !order.pickup_delivery &&
        order.related_shipment_orders &&
        order.related_shipment_orders.length > 0
      ) {
        options.push({
          action: "separate",
          label: "Enviar orden por separado",
        });
      }

      return options;
    },

    getDeliveryAddressOptions() {
      const options = [{ value: null, label: "Seleccionar", disabled: false }];

      this.order.branch.addresses.forEach((address) => {
        if (address.pivot.valid_for_shipping) {
          options.push({
            value: address.id,
            label: `${address.street} #${address.exterior_number}${
              address.shipping_price
                ? " - " +
                  this.integerToCurrency(address.shipping_price) +
                  " por envío"
                : ""
            }`,
          });
        }
      });

      return options;
    },
  },
};
</script>